export default __webpack_public_path__ + "static/media/submit_button.751a1945.png";